import { MEDIA, BUSINESS } from "../../lib/business";
import { CheckCircle2 } from "lucide-react";

import facilityImg from "../../assets/about/facility.jpg";

const POINTS = [
  "In-house manufacturing at Barhi Industrial Area, Sonipat",
  "FSSAI, GMP & AYUSH certified quality systems",
  "Private label, contract manufacturing and bulk supply",
  "End-to-end execution — formulation, R&D, production and packaging",
  "Complete design support — packaging, label and brand creatives",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 relative">
          <div className="aspect-[4/5] overflow-hidden border border-[#E5E5E5]">
            <img
              src={facilityImg}
              alt="White Bull Global capsule manufacturing line — automated filling and bottling"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div
            className="hidden md:flex absolute -bottom-10 -right-8 bg-white border border-[#E5E5E5] p-6 w-64"
          >
            <div>
              <div className="overline">Facility</div>
              <div className="font-serif-display text-lg text-[#1A1A1A] mt-2 leading-snug">
                Barhi Industrial Area
                <br />
                HSIIDC Phase-III, Sonipat
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="overline">
            <span className="gold-divider mr-3 align-middle" />
            About White Bull Global
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#1A1A1A] mt-6 leading-tight">
            A manufacturer built
            <br />
            around one principle.
          </h2>
          <p className="text-[#595959] mt-6 leading-relaxed">
            {BUSINESS.shortName} is a nutraceutical and supplement manufacturer
            operating out of HSIIDC Phase-III, Sonipat. We produce healthcare,
            fitness and sport-nutrition formulations for brands and
            institutions — built on certified quality systems and a simple
            commitment:{" "}
            <span className="text-[#1A1A1A] font-semibold">
              purity is priority.
            </span>
          </p>
          <p className="text-[#595959] mt-4 leading-relaxed">
            From ingredient sourcing, formulation and R&amp;D to packaging
            design, label creatives and finished packs — every step is handled
            inside our facility, so your product arrives consistent, compliant,
            and market-ready.
          </p>

          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li
                key={p}
                data-testid={`about-point-${p.slice(0, 12).replace(/\s+/g, "-").toLowerCase()}`}
                className="flex items-start gap-3 text-[#2A2A2A]"
              >
                <CheckCircle2
                  className="w-5 h-5 text-[#D4AF37] mt-0.5 flex-shrink-0"
                  strokeWidth={1.6}
                />
                <span className="leading-relaxed">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
